import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import Form from '@piconetworks/pkg-form';
import ChooseNewsletter from '@piconetworks/pkg-choose-newsletter';

var Newsletters = function Newsletters(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    fieldContainerProps = _ref.fieldContainerProps,
    defaultValue = _ref.defaultValue,
    linkColor = _ref.linkColor,
    newsletterFilter = _ref.newsletterFilter,
    _ref$newsletters = _ref.newsletters,
    newsletters = _ref$newsletters === void 0 ? [] : _ref$newsletters,
    previewMode = _ref.previewMode,
    showMore = _ref.showMore;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(Form.Field, _extends({}, fieldContainerProps, {
    style: {
      marginBottom: 0
    }
  }), /*#__PURE__*/React.createElement(ChooseNewsletter, {
    currentProductOptionId: null,
    newsletters: newsletters,
    selectedTier: null,
    groupTier: null,
    containerType: null,
    disableGroup: null,
    newsletterFilter: newsletterFilter,
    onHasNewsletters: function onHasNewsletters() {},
    onHasNoNewsletters: function onHasNoNewsletters() {},
    isSingleColumn: true,
    isReadyToMount: true,
    linkColor: linkColor,
    defaultValue: defaultValue,
    previewMode: previewMode,
    showMore: showMore
  })));
};
Newsletters.propTypes = {
  newsletters: PropTypes.arrayOf(PropTypes.shape({
    classification: PropTypes.string,
    access_tier_ids: PropTypes.object
  })),
  newsletterFilter: PropTypes.string,
  defaultValue: PropTypes.array,
  linkColor: PropTypes.string,
  previewMode: PropTypes.bool
};

export { Newsletters as default };
//# sourceMappingURL=index.js.map
